import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { allSchoolsFromServer } from "./usersListService";

const UserslList = () => {
    const [isLoading, setIsloading] = useState(true);
    const [schools, setSchools] = useState([]);

    useEffect(() => {
        allSchools();
    }, []);

    const allSchools = async () => {
        try {
            setIsloading(true);

            const data = await allSchoolsFromServer();

            setSchools(
                Array.isArray(data)
                    ? data
                    : data.schools || []
            );
        } catch (err) {
            toast.error(
                err.response?.data?.message || "خطا در دریافت لیست مدارس"
            );
        } finally {
            setIsloading(false);
        }
    };

    const deleteSchool = async (school) => {
        // API حذف مدرسه
        // await deleteSchoolFromServer(school.id);

        // بعد از موفقیت حذف
        setSchools((prev) =>
            prev.filter(
                (item) =>
                    (item.id ?? item["شناسه"]) !==
                    (school.id ?? school["شناسه"])
            )
        );

        toast.success("مدرسه با موفقیت حذف شد");
    };

    const formatPersianDate = (date) => {
        if (!date || date.startsWith("0001-01-01")) {
            return "—";
        }

        return new Intl.DateTimeFormat("fa-IR", {
            timeZone: "Asia/Tehran",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        }).format(new Date(date));
    };

    return (
        <div className="container-fluid py-4" dir="rtl">

            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 className="fw-bold mb-1">لیست کاربران</h4>
                    <p className="text-muted mb-0 small">
                        مدیریت و مشاهده کاربران ثبت‌شده
                    </p>
                </div>

                <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill">
                    {schools.length} مدرسه
                </span>
            </div>

            {/* Loading */}
            {isLoading && (
                <div className="d-flex justify-content-center align-items-center py-5">
                    <div
                        className="spinner-border text-primary"
                        role="status"
                    >
                        <span className="visually-hidden">
                            Loading...
                        </span>
                    </div>
                </div>
            )}

            {/* Table */}
            {!isLoading && (
                <div className="card border-0 shadow-sm rounded-4 overflow-hidden">

                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">

                            <thead className="table-light">
                                <tr>
                                    <th className="px-4 py-3">
                                        نام مدرسه
                                    </th>

                                    <th className="py-3">
                                        وضعیت
                                    </th>
                                    <th className="py-3">
                                        تاریخ ایجاد
                                    </th>

                                    <th className="py-3">
                                        آخرین استفاده
                                    </th>
                                    <th
                                        className="text-center py-3"
                                        style={{ width: "130px" }}
                                    >
                                        عملیات
                                    </th>
                                </tr>
                            </thead>
<tbody>
    {schools.map((school, index) => {
        const name = school.name ?? "بدون نام";
        const isActive = school.isActive;

        return (
            <tr
                key={school.id ?? index}
            >
                <td className="px-4">
                    <div className="d-flex align-items-center gap-3">

                        <div
                            className="rounded-3 bg-primary-subtle text-primary d-flex align-items-center justify-content-center fw-bold"
                            style={{
                                width: "42px",
                                height: "42px"
                            }}
                        >
                            {name.toString().charAt(0)}
                        </div>

                        <div>
                            <div className="fw-semibold">
                                {name}
                            </div>

                            <small className="text-muted">
                                مدرسه
                            </small>
                        </div>

                    </div>
                </td>

                <td>
                    {isActive ? (
                        <span className="badge rounded-pill bg-success-subtle text-success px-3 py-2">
                            فعال
                        </span>
                    ) : (
                        <span className="badge rounded-pill bg-secondary-subtle text-secondary px-3 py-2">
                            غیرفعال
                        </span>
                    )}
                </td>

                <td>
                    <div className="small">
                        {formatPersianDate(school.createdAt)}
                    </div>
                </td>

                <td>
                    <div className="small">
                        {formatPersianDate(school.usedAt)}
                    </div>
                </td>

                <td className="text-center">
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-danger rounded-3 px-3"
                        onClick={() => deleteSchool(school)}
                    >
                        <i className="bi bi-trash3 me-1"></i>
                        حذف
                    </button>
                </td>
            </tr>
        );
    })}

    {schools.length === 0 && (
        <tr>
            <td
                colSpan="5"
                className="text-center py-5"
            >
                <div className="text-muted">
                    <i
                        className="bi bi-building"
                        style={{ fontSize: "40px" }}
                    ></i>

                    <div className="mt-3 fw-semibold">
                        مدرسه‌ای یافت نشد
                    </div>

                    <small>
                        هنوز مدرسه‌ای ثبت نشده است.
                    </small>
                </div>
            </td>
        </tr>
    )}
</tbody>

                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserslList;